import { useSyncExternalStore } from 'react';
import { createLocalListStore } from '@/lib/localStore';

const favoritesStore = createLocalListStore('jjzc:favorites');

export function useFavorites() {
  const favoriteIds = useSyncExternalStore(
    favoritesStore.subscribe,
    favoritesStore.getSnapshot,
    favoritesStore.getSnapshot
  );

  return {
    favoriteIds,
    isFavorite: (id: string) => favoriteIds.includes(id),
    toggleFavorite: (id: string) => favoritesStore.toggle(id),
  };
}